import { DateTime } from "luxon";
import { format } from "timeago.js";

export enum NumericType {
  Numeric = "numeric",
  Digit = "2-digit",
}
export enum StringType {
  Long = "long",
  Short = "short",
}

export type ConfigType = {
  year?: NumericType;
  month?: StringType;
  day?: NumericType;
  hour?: NumericType;
  minute?: NumericType;
  hour12?: boolean;
};

export type DateRangeType = {
  startDate: Date;
  endDate: Date;
  odd: boolean;
};

const dfault_config: ConfigType = {
  year: NumericType.Numeric,
  month: StringType.Short,
  day: NumericType.Numeric,
  hour: NumericType.Numeric,
  minute: NumericType.Numeric,
  hour12: true,
};

export function toDate(
  date: string | undefined | null | false,
  config?: ConfigType,
  type?: "time",
): string {
  if (date === false) {
    date = DateTime.now().toSQL();
  } else if (!date) return "-";

  const system_Date = new Date(date);
  const currentYear = new Date().getFullYear();

  const getConfig = (d: Date): ConfigType => {
    const base = config || dfault_config;
    if (d.getFullYear() !== currentYear) {
      return { ...base, year: "numeric" } as ConfigType;
    }
    return base;
  };

  // if date has no time, return date as is
  if (
    system_Date.getHours() === 0 &&
    system_Date.getMinutes() === 0 &&
    system_Date.getSeconds() === 0
  ) {
    return system_Date.toLocaleDateString("en", getConfig(system_Date));
  }

  const local_date = DateTime.fromSQL(date, { zone: "UTC" })
    .toLocal()
    .toString();
  const localDateObj = new Date(local_date);

  if (type === "time") {
    return localDateObj.toLocaleTimeString("en", getConfig(localDateObj));
  }

  return localDateObj.toLocaleDateString("en", getConfig(localDateObj));
}

export function timeAgo(date: string | undefined | false): string {
  if (date === false) {
    date = DateTime.now().toSQL();
  } else if (!date) return "-";
  return format(DateTime.fromSQL(date, { zone: "UTC" }).toLocal().toString());
}

export function getWeekDates(
  weekNumber: number,
  yearNumber?: number | false,
): string {
  if (!yearNumber) {
    yearNumber = new Date().getFullYear();
  }
  const dt = DateTime.fromObject({
    weekYear: yearNumber,
    weekNumber: weekNumber,
  });

  const dateFromStr = dt.startOf("week");
  const dateToStr = dt.endOf("week");
  const inital_day = dateFromStr.toLocaleString({
    month: "short",
    day: "numeric",
  });
  const end_day = dateToStr.toLocaleString({ month: "short", day: "numeric" });
  return `${inital_day} - ${end_day}`;
}

export function weekDates(date: DateRangeType): string {
  ////check if current year is the same as date range
  const current_year = new Date().getFullYear();
  const start_year = date.startDate.getFullYear();
  const end_year = date.endDate.getFullYear();
  let year = "";
  let year_end = "";
  if (current_year !== start_year) {
    year = ` ${start_year}`;
  }
  if (start_year !== end_year) {
    year_end = ` ${end_year}`;
  }
  const inital_day = date.startDate.toLocaleDateString("en", {
    month: "short",
    day: "numeric",
  });
  const end_day = date.endDate.toLocaleDateString("en", {
    month: "short",
    day: "numeric",
  });
  return `${inital_day}${year_end ? year : ""} - ${end_day}${
    year_end ? year_end : year
  } `;
}
